// extracted by mini-css-extract-plugin
export default {"burgerWrapper":"burger_burgerWrapper__pbHH7","icon":"burger_icon__wHscK"};